import React from "react";

import {
  Column,
  Columns,
  Hidden,
  Section,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import { Video } from "src/components/Video";

import content from "./content.json";

export const MediaSection: React.FC = () => (
  <Section backgroundColor="grey50">
    <Hidden above="sm">
      <Stack space="large">
        <Stack space="medium">
          <Video content={content.video} />
          <Text variant="subtitle" align="left">
            {content.heading}
          </Text>
          <Text>{content.subheading}</Text>
          <Text>{content.text}</Text>
        </Stack>
      </Stack>
    </Hidden>

    <Hidden below="md">
      <Stack space="xxlarge">
        <Columns>
          <Column>
            <Stack space="large">
              <Text variant="subtitle" align="left">
                {content.heading}
              </Text>
              <Text>{content.subheading}</Text>
              <Text>{content.text}</Text>
            </Stack>
          </Column>
          <Column>
            <Stack space="xlarge">
              <Stack space="small">
                <Video content={content.video} />
              </Stack>
            </Stack>
          </Column>
        </Columns>
      </Stack>
    </Hidden>
  </Section>
);
